module.exports = __webpack_public_path__ + "static/media/Recording.d3345a3f.mp3";